const bankImageSizes = {
    visa: { width: 50, height: 16 },
    amex: { width: 34, height: 32 },
    mastercard: { width: 34, height: 26 },
    santander: { width: 75, height: 51 },
    bancoppel: { width: 78, height: 51 },
    bbva: { width: 100, height: 21 },
    nubank: { width: 41, height: 26 },
    citibanamex: { width: 85, height: 12 },
    scotiabank: { width: 78, height: 14 }
};

export { bankImageSizes };